import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import benchmarkUtility from '@sparta.sales.utilities/benchmark-utility/dist/es6.js';
import SiemaSlider from '@sparta.homepage.utilities/siema-slider-utility/dist/es6.js';
import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { curve } from '@sparta.homepage.helpers/homepage-helper/dist/es6.js';
import { secureLink } from '@sparta.global.helpers/secure-link-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div id=\"bmhTileContents\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"bmhTileContents") : stack1),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":2,"column":38},"end":{"line":2,"column":68}}}))
    + "\"></div>\r\n\r\n  <div class=\"headlines\">\r\n    <h2>"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"h2Heading") : stack1), depth0)) != null ? stack1 : "")
    + "</h2>\r\n    <p class=\"show-for-medium-up subheading\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"subheading") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n  </div>\r\n\r\n  <div class=\"curve\">\r\n    <div id=\"bmhCarouselContainer\">\r\n      <a aria-controls=\"bmhCarousel\"\r\n        href=\"javascript:void(0)\"\r\n        role=\"button\"\r\n        id=\"bmh-tiles-carousel-left\"\r\n        class=\"spa-icon arrow arrow--prev hide-for-large-up prev-arrow\"\r\n        tabindex=\"0\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"prevArrowContent") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </a>\r\n      <ul class=\"slider\" id=\"bmhCarousel\" tabindex=\"-1\" role=\"presentation\" aria-label=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"slideAriaLabel") : stack1), depth0))
    + "\">\r\n      </ul>\r\n      <a aria-controls=\"bmhCarousel\"\r\n        href=\"javascript:void(0)\"\r\n        role=\"button\"\r\n        id=\"bmh-tiles-carousel-right\"\r\n        class=\"spa-icon arrow arrow--next hide-for-large-up next-arrow\"\r\n        tabindex=\"0\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"nextArrowContent") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n      </a>\r\n    </div>\r\n    "
    + ((stack1 = (lookupProperty(helpers,"curve")||(depth0 && lookupProperty(depth0,"curve"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"top","#fff","show-for-large-up",{"name":"curve","hash":{},"data":data,"loc":{"start":{"line":29,"column":4},"end":{"line":29,"column":48}}})) != null ? stack1 : "")
    + "\r\n    "
    + ((stack1 = (lookupProperty(helpers,"curve")||(depth0 && lookupProperty(depth0,"curve"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"bottom","#fff","show-for-large-up",{"name":"curve","hash":{},"data":data,"loc":{"start":{"line":30,"column":4},"end":{"line":30,"column":51}}})) != null ? stack1 : "")
    + "\r\n  </div>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"column small-10 small-push-1 medium-8 medium-push-2 explore-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"exploreMoreText") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":6},"end":{"line":37,"column":13}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"visitBmhBtnMobile") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":6},"end":{"line":40,"column":13}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"visitBmhBtnTabletUp") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":6},"end":{"line":43,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n  </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <p class=\"explore-more\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"exploreMoreText") : stack1), depth0)) != null ? stack1 : "")
    + "</p>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = (lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"visitBmhBtnMobile") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"bmhHost") : stack1),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":39,"column":8},"end":{"line":39,"column":67}}})) != null ? stack1 : "")
    + "\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        "
    + ((stack1 = (lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"LINKS") : stack1)) != null ? lookupProperty(stack1,"visitBmhBtnTabletUp") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"bmhHost") : stack1),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":42,"column":8},"end":{"line":42,"column":69}}})) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"site") : depth0)) != null ? lookupProperty(stack1,"disableBMH") : stack1),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":46,"column":11}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <li role=\"presentation\" class=\"slide "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0))
    + " slide-"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"index") || (data && lookupProperty(data,"index"))) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data,"loc":{"start":{"line":2,"column":62},"end":{"line":2,"column":72}}}) : helper)))
    + "\"\r\n    style=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"scale") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":11},"end":{"line":3,"column":102}}})) != null ? stack1 : "")
    + "\"\r\n    tabindex=\"-1\">\r\n    <img\r\n      src=\""
    + ((stack1 = lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"backgroundImage") : depth0),((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"viewport")),{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":6,"column":11},"end":{"line":6,"column":59}}})) != null ? stack1 : "")
    + "\"\r\n      alt=\"\"\r\n      role=\"presentation\"\r\n      class=\"bmh-tile-image\"\r\n      loading=\"lazy\"\r\n    />\r\n    <a href=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"bmhHost") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":13},"end":{"line":12,"column":57}}})) != null ? stack1 : "")
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"url") : depth0), depth0))
    + "\"\r\n      id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\"\r\n      class=\"slide-content "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"actionType") : depth0)) != null ? lookupProperty(stack1,"options") : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":27},"end":{"line":14,"column":89}}})) != null ? stack1 : "")
    + "\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"actionType") : depth0)) != null ? lookupProperty(stack1,"options") : stack1),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":90},"end":{"line":15,"column":62}}})) != null ? stack1 : "")
    + ">\r\n      <img src=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"icon") : depth0)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + "\" alt=\"\">\r\n      <p class=\"cnx-light\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n    </a>\r\n  </li>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "background-size:contain;background-color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"backgroundColor") : depth0), depth0))
    + ";";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"bmhHost")), depth0));
},"6":function(container,depth0,helpers,partials,data) {
    return "spa-ui-layer-link spa-fn";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n      data-options='"
    + ((stack1 = (lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"actionType") : depth0)) != null ? lookupProperty(stack1,"options") : stack1),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":15,"column":20},"end":{"line":15,"column":54}}})) != null ? stack1 : "")
    + "'";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":20,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.homepage.modules/bmh-legacy-module",
  "version": "1.0.0",
  "id": "bmhLegacyModule",
  "containerID": "homepageBmhLegacyModule",
  "moduleName": "homepage-bmh-legacy-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "bmh-legacy-module",
  "data": {
    "init": "bmhLegacyModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$1(context, {
      "helpers": {
        curve,
        secureLink,
        json
      },
      "partials": {
        "bmh-slides": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "bmh-slides": renderTemplate
  },
  "helpers": {
    curve,
    secureLink,
    json
  },
  "dependencies": {
    "@sparta.sales.utilities/benchmark-utility": "^1.0.0",
    "@sparta.homepage.helpers/homepage-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/secure-link-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.homepage.utilities/siema-slider-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.0"
  },
  "stores": []
};

const SLIDER_SELECTOR = '#bmhCarousel';
const SLIDE_TRANSITION = 200;

/**
 * bmh-legacy-module
 * module_js_id: bmhLegacyModuleJS
 */
/**
 * @exports
 * @class bmhLegacyModuleJS
 * @extends Module
 */
class bmhLegacyModuleJS extends Module {
  /**
   * @description Creates an instance of bmhLegacyModuleJS
   * @method constructor
   * @param {Object} options options
   * @param {Object} context context
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    if (spaParams.siteParams.jsTimer) {
      benchmarkUtility.init(this);
    }
  }

  /**
   * @description Initialize the module
   * @method init
   * @returns {void} none
   */
  init() {
    if (spaParams.siteParams.disableBMH) {
      return; // Chicken switch
    }
    this.target = this.settings.target;
    this.sliderContainer = this.target.querySelector(SLIDER_SELECTOR);
    this.carouselAriaContent = this.sliderContainer.getAttribute('aria-label');
    this.sliderContainer.removeAttribute('aria-label');
    this.isFirstLoad = true;
    this.largeUp = window.matchMedia('(min-width: 1025px)');
    this.mediumDown = window.matchMedia('(max-width: 1024px)');
    this.bmhSliderContentJCR = JSON.parse(this.target.querySelector('#bmhTileContents').dataset.jcr);
    this.slidesPartial = _moduleConfig.partials['bmh-slides'];
    this.setContent();
    if (this.mediumDown.matches) {
      this.bindEventsOnceForMediumDown();
      this.createSlider();
    } else {
      // bind resizing from large-up to medium-down
      this.mediumDown.addListener(this.handleResizeToMediumDown.bind(this));
    }

    // event published in utility/homepage/prerender-seo.js to destroy carousel
    this.Events.sub('prerender-seo-utility:destroy-siema-carousel', () => {
      this.siemaSlider.destroy(true);
    });
  }

  /**
   * @description binds needed events on medium-down screens
   * @method bindEventsOnceForMediumDown
   * @returns {void} none
   */
  bindEventsOnceForMediumDown() {
    if (this.isFirstLoad === true) {
      this.largeUp.addListener(this.handleResizeToLargeUp.bind(this));
      this.mediumDown.addListener(this.handleResizeToMediumDown.bind(this));

      // bind click events to slider arrows
      ['next', 'prev'].forEach(direction => {
        const arrowElem = this.target.querySelector(`.${direction}-arrow`);
        ['click', 'keypress'].forEach(event => {
          arrowElem.addEventListener(event, this.slide.bind(this, direction));
        });
      });
      this.isFirstLoad = false;
    }
  }

  /**
   * @description initializes siema slider, and updates slides and slider transition duration
   * @method createSlider
   * @returns {void} none
   */
  createSlider() {
    this.initSlider();
    // grab the new slides that have been added, and update slider
    const newSlides = Array.from(this.sliderContainer.querySelectorAll('li'));
    this.siemaSlider.updateSlides(newSlides);
    this.updateSlideDuration(SLIDE_TRANSITION);
  }

  /**
   * @description initializes the siema Slider
   * @method initSlider
   * @returns {void} none
   */
  initSlider() {
    // using siema-slider utility: components/utilities/homepage/siema-slider
    this.siemaSlider = new SiemaSlider({
      selector: SLIDER_SELECTOR,
      duration: 0,
      // set to 0 initially to hide transition to the current slide
      easing: 'ease-out',
      perPage: {
        480: 1,
        767: 2,
        1025: 4
      },
      startIndex: 3,
      draggable: true,
      threshold: 50,
      loop: false,
      onInit: () => {},
      onChange: () => {}
    });
    this.siemaSlider.init();
  }

  /**
   * @description Used to determine the current viewport. This value is passed to the partial
   *  so we only have to render 1 image (instead of 1 small, 1 med, & 1 large)
   * @returns {String} viewport name
   */
  getGenericViewport() {
    const {
      mediaQueryInfo
    } = spartaMediaQueryUtility.getCurrentViewport();
    let viewport = 'small';
    if (mediaQueryInfo['medium-only'] === true) {
      viewport = 'medium';
    } else if (mediaQueryInfo['large-only'] === true) {
      viewport = 'large';
    }
    return viewport;
  }

  /**
   * @description Sets content for the large-up view or slider
   * @method setContent
   * @returns {void} none
   */
  setContent() {
    this.sliderContainer.innerHTML = this.slidesPartial({
      data1: this.bmhSliderContentJCR.default,
      bmhHost: spaParams.siteParams.bmhHost,
      viewport: this.getGenericViewport()
    });
  }

  /**
   * @description restores the correct slide duration
   * slideDuration was set to 0 initially to hide the slider initialization and
   * transformation back to the current slide
   * @method updateSlideDuration
   * @param { number } duration - the actual slide duration for the slider config
   * @returns {void} none
   */
  updateSlideDuration(duration) {
    setTimeout(() => {
      this.siemaSlider.updateSlideDuration(duration);
    }, 0);
  }

  /**
   * @description calls method to slide depending on direction that was passed
   * @method slide
   * @param { string } direction - direction to slide
   * @param { object } event - event calling method
   * @returns {void} none
   */
  slide(direction, event) {
    const keyCode = event.which || event.keyCode;
    if (keyCode === 13 || event.type === 'click') {
      this.siemaSlider[direction](this.sliderContainer.focus());
    }
  }

  /**
   * @description destroys slider on large-up screen sizes
   * @method handleResizeToLargeUp
   * @returns {void} none
   */
  handleResizeToLargeUp() {
    if (this.largeUp.matches) {
      this.sliderContainer.removeAttribute('aria-label');
      this.siemaSlider.destroy(true);
    }
  }

  /**
   * @description adds slider on medium-down screen sizes
   * @method handleResizeToMediumDown
   * @returns {void} none
   */
  handleResizeToMediumDown() {
    if (this.mediumDown.matches) {
      this.sliderContainer.setAttribute('aria-label', this.carouselAriaContent);
      this.bindEventsOnceForMediumDown();
      this.setContent();
      this.createSlider();
    }
  }
}
registerModuleClass({
  moduleClass: bmhLegacyModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { bmhLegacyModuleJS as default, moduleConfig };
